export default __webpack_public_path__ + "static/media/pct.0541f6a4.woff";